import { useEffect, useState } from 'react';
import Tabs from './components/Tabs';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';

export enum PageNavType {
    Benefit = 'Benefit',
    Endorsement = 'Endorsement',
    What = 'What',
    Comparison = 'Comparison',
    Why = 'Why',
    FAQ = 'FAQ',
    Blog = 'Blog',
}

export default function TheComp() {
    const { t } = useLang('theProduct.PageNav');
    const { locale = 'us' } = useRouter();
    let listA = [
        {
            href: PageNavType.Benefit,
            title: t('title1'),
        },
        {
            href: PageNavType.Endorsement,
            title: t('title2'),
        },
        {
            href: PageNavType.What,
            title: t('title3'),
        },
        {
            href: PageNavType.Comparison,
            title: t('title4'),
        },
        {
            href: PageNavType.Why,
            title: t('title5'),
        },
        {
            href: PageNavType.Blog,
            title: t('title7'),
        },
        {
            href: PageNavType.FAQ,
            title: t('title6'),
        },
    ];
    if (['mx', 'br'].includes(locale)) {
        listA = [
            {
                href: PageNavType.What,
                title: t('title3'),
            },
            {
                href: PageNavType.Comparison,
                title: t('title4'),
            },
            {
                href: PageNavType.Why,
                title: t('title5'),
            },
            {
                href: PageNavType.FAQ,
                title: t('title6'),
            },
        ];
    }

    const [height, setHeight] = useState(0);
    useEffect(() => {
        const header = document.querySelector('#global-nav-product') as HTMLElement;
        if (header) {
            const resize = new ResizeObserver((entries) => {
                entries.forEach((entry) => {
                    const { height } = entry.contentRect;
                    setHeight(height);
                });
            });
            resize.observe(header);
            return () => resize.disconnect();
        }
    }, []);

    return <Tabs list={listA} sticky stickyHeight={height} />;
}
